import React from "react";
import { Route, Switch } from "react-router-dom";
import ClientsList from "../../../components/shared-components/Clients/ClientsList/ClientsList";
import ClientDashboard from "../../../components/shared-components/Clients/ClientDashboard/ClientDashboard";
import ClientCampaignOverview from "../../../components/shared-components/Clients/ClientCampaignOverview/ClientCampaignOverview";

const ClientsAdmin = () => {
  return (
    <>
      <Switch>
        <Route exact path="/clients">
          <ClientsList />
        </Route>
        <Route exact path="/clients/:username/campaign">
          <ClientCampaignOverview />
        </Route>
        <Route exact path="/clients/:username/dashboard">
          <ClientDashboard />
        </Route>
      </Switch>
    </>
  );
};

export default ClientsAdmin;
